import { Button } from "@components/ui/Button"
import { ButtonFragment } from "@generated-types"
import { useButtonProps } from "@hooks/useButtonProps"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Button",
  icon: "forms",
  tags: ["button"],
}

export default defineBlock("content/button", (props) => {
  const buttonProps = useButtonProps(props.link! as ButtonFragment, {
    defaultVariant: "default",
    primaryVariant: "primary",
  })

  const button = (
    <Button
      {...buttonProps}
      icon={undefined}
      rightIcon={buttonProps.icon || (buttonProps?.target === "_blank" ? "externalLink" : undefined)}
      data-mixpanel-block="Button"
    >
      <EditableText
        store="label"
        defaultValue={props.link?.title}
        placeholder="Button"
        appendOnEnter="core/paragraph"
        removeOnDelete
        plainText
      />
    </Button>
  )

  return button
})
